export enum S3BucketName {
  POINT_CODE = 'POINT_CODE',
  ACCOUNTS = 'ACCOUNTS',
  PORT_REPORT = 'PORT',
}
